// The shared canvas every wordmark is drawn on in the design. The sprite build pads each logo's
// viewBox out to this box so all of them share one scale; without it preserveAspectRatio enlarges
// each logo until it hits a box edge, which is a different factor per logo (up to 31% apart).
// Rendering the box at these dimensions therefore reproduces the design 1:1.
export const logoBox = {
    width: 229,
    height: 72,
};
